import { z } from 'zod';

import { tokenStore } from './token-store';

const viewerIdentitySchema = z.object({
  login: z.string().regex(/^[a-zA-Z0-9_-]+$/),
  profileName: z.string().nullish(),
  avatarUrl: z.string().nullish(),
  registeredAt: z.string().nullish().catch(null),
  createdAt: z.string().nullish().catch(null),
});

export type ViewerIdentity = z.infer<typeof viewerIdentitySchema>;

export const hasAccountSession = () => {
  const session = tokenStore.get();
  return Boolean(session && session.sessionType !== 'guest');
};

export const getViewerIdentity = (): ViewerIdentity | null => {
  const session = tokenStore.get();
  const user = viewerIdentitySchema.safeParse(session?.user);
  if (user.success) return user.data;
  const accessToken = session?.accessToken;
  const encodedPayload = accessToken?.split('.')[1];
  if (!encodedPayload) return null;

  try {
    const base64 = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');
    const bytes = Uint8Array.from(atob(base64), (character) => character.charCodeAt(0));
    const payload: unknown = JSON.parse(new TextDecoder().decode(bytes));
    const result = viewerIdentitySchema.safeParse(payload);
    return result.success ? result.data : null;
  } catch {
    return null;
  }
};
